// Sujet à proposer en fin de quiz (« Sujet suivant »), à partir de l'arbre déjà filtré
// par le parcours. Sans abonnement : le prochain sujet d'essai jamais ouvert (les
// acheteurs ont enchaîné 2-3 essais avant de payer). Avec accès : le prochain sujet
// jamais vu, sinon le moins couvert — sans cela un abonné refait indéfiniment le même.
// L'ordre suit l'affichage, en repartant juste après le sujet qui vient d'être joué.
export function pickNextSubject(categories, { hasAccess, currentId = null, excludeIds = [] }) {
    const flat = (categories || []).flatMap(c => c.sous_sujets || []);
    const exclude = new Set([...excludeIds, currentId].filter(Boolean).map(Number));
    const start = currentId ? flat.findIndex(ss => Number(ss.id) === Number(currentId)) + 1 : 0;
    const ordered = [...flat.slice(start), ...flat.slice(0, start)]
        .filter(ss => !exclude.has(Number(ss.id)) && (ss.nb_questions || 0) > 0 && (hasAccess || ss.is_demo));

    const fresh = ordered.find(ss => !(ss.answered_count > 0) && !ss.has_session);
    if (fresh) return fresh;
    if (!hasAccess) return null;
    const partial = ordered
        .filter(ss => (ss.answered_count || 0) < ss.nb_questions)
        .sort((a, b) => (a.answered_count / a.nb_questions) - (b.answered_count / b.nb_questions));
    return partial[0] || null;
}

// Couverture du programme : questions distinctes vues (bornées au nombre servi, une
// question retirée depuis ne gonfle pas le compte) sur le total du périmètre affiché.
export function programmeCoverage(categories) {
    let seen = 0, total = 0;
    for (const c of categories || []) for (const ss of c.sous_sujets || []) {
        const n = ss.nb_questions || 0;
        total += n;
        seen += Math.min(ss.answered_count || 0, n);
    }
    const pct = total ? (seen / total) * 100 : 0;
    return { seen, total, pctLabel: seen > 0 && pct < 1 ? '< 1 %' : `${Math.round(pct)} %` };
}
